import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// // There is a bug with service worker & firebase causing caching issues (https://github.com/facebookincubator/create-react-app/pull/2441)
//registerServiceWorker();
unregister();


// WEBPACK FOOTER //
// ./src/index.js